import { render, staticRenderFns } from "./transportTracking.vue?vue&type=template&id=bebc52c4"
import script from "./transportTracking.vue?vue&type=script&lang=js"
export * from "./transportTracking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports